import classNames from "classnames"
import React from "react"
import { mergeFilter } from "../../../utils/filters"
import FiltersSidebarElement from "../FiltersSidebarElement"
import { FilterCategory } from "../types"

interface Props {
  filters: FilterCategory[]
  onFiltersUpdate: (filters: FilterCategory[]) => void
}

const FiltersSidebar = ({ filters, onFiltersUpdate }: Props) => {
  const [expanded, setExpanded] = React.useState<string[]>(
    filters.length > 0 ? [filters[0].id] : []
  )

  const handleFilterUpdate = (filter: FilterCategory) => {
    onFiltersUpdate(mergeFilter(filters, filter))
  }

  const handleExpand = (filter: FilterCategory) => {
    if (expanded.includes(filter.id)) {
      setExpanded(expanded.filter((x) => x !== filter.id))
    } else {
      setExpanded([...expanded, filter.id])
    }
  }

  return (
    <div>
      {filters.map((x, index) => (
        <div
          key={index}
          className={classNames("mt-1", x.active ? "" : "hidden")}
        >
          <FiltersSidebarElement
            filter={x}
            onFilterUpdate={handleFilterUpdate}
            expanded={expanded.includes(x.id)}
            onExpandToggle={() => handleExpand(x)}
          />
        </div>
      ))}
    </div>
  )
}

export default FiltersSidebar
